module.exports = __webpack_public_path__ + "img/static.5dedae03.png";